<template>
  <div>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="secondary"
      class="mb-3"
    />
    <v-alert
      v-if="loadError"
      type="error"
      dense
      outlined
      border="left"
    >
      {{ loadError }}
    </v-alert>

    <v-expansion-panels
      v-if="!loading && !loadError"
      v-model="openPanels"
      multiple
      accordion
      flat
    >
      <!-- Geral -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="d-flex align-center">
            <v-icon
              color="secondary"
              class="mr-2"
            >
              mdi-toggle-switch-outline
            </v-icon>
            <div>
              <div class="text-subtitle-1">
                Geral
              </div>
              <div class="text-caption grey--text">
                Permissões de configuração por usuário.
              </div>
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row dense>
            <v-col
              cols="12"
              md="4"
            >
              <v-switch
                v-model="forms.geral.permite_configuracao_agenda"
                label="Permite configuração de agenda"
                inset
                dense
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-switch
                v-model="forms.geral.permite_configuracao_prontuario"
                label="Permite configuração de prontuário"
                inset
                dense
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-switch
                v-model="forms.geral.permite_configuracao_impresso"
                label="Permite configuração de impressos"
                inset
                dense
                hide-details
              />
            </v-col>
          </v-row>
          <div class="mt-3 text-right">
            <v-btn
              color="secondary"
              small
              :loading="saving.geral"
              @click="save('geral')"
            >
              Salvar
            </v-btn>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Prontuário -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="d-flex align-center">
            <v-icon
              color="primary"
              class="mr-2"
            >
              mdi-file-document-edit-outline
            </v-icon>
            <div>
              <div class="text-subtitle-1">
                Prontuário
              </div>
              <div class="text-caption grey--text">
                Vista padrão da evolução.
              </div>
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row dense>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="forms.prontuario.evolucao_vista_padrao"
                label="Vista padrão da evolução"
                :items="evolucaoOpts"
                dense
                outlined
                hide-details
              />
            </v-col>
          </v-row>
          <div class="mt-3 text-right">
            <v-btn
              color="secondary"
              small
              :loading="saving.prontuario"
              @click="save('prontuario')"
            >
              Salvar
            </v-btn>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Agenda -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="d-flex align-center">
            <v-icon
              color="primary"
              class="mr-2"
            >
              mdi-calendar-clock
            </v-icon>
            <div>
              <div class="text-subtitle-1">
                Agenda
              </div>
              <div class="text-caption grey--text">
                Vista, exibição e bloqueios na agenda.
              </div>
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row dense>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="forms.agenda.vista_padrao"
                label="Vista padrão"
                :items="vistaAgendaOpts"
                dense
                outlined
                hide-details
              />
            </v-col>
          </v-row>
          <v-row
            dense
            class="mt-2"
          >
            <v-col
              v-for="f in agendaSwitches"
              :key="f.key"
              cols="12"
              md="6"
            >
              <v-switch
                v-model="forms.agenda[f.key]"
                :label="f.label"
                inset
                dense
                hide-details
              />
            </v-col>
          </v-row>
          <div class="mt-3 text-right">
            <v-btn
              color="secondary"
              small
              :loading="saving.agenda"
              @click="save('agenda')"
            >
              Salvar
            </v-btn>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Impressos -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="d-flex align-center">
            <v-icon
              color="success"
              class="mr-2"
            >
              mdi-printer-outline
            </v-icon>
            <div>
              <div class="text-subtitle-1">
                Impressos
              </div>
              <div class="text-caption grey--text">
                Cabeçalho, rodapé, margens e assinatura.
              </div>
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row dense>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="forms.impressos.formato_pagina"
                label="Formato de página"
                :items="formatoPaginaOpts"
                clearable
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="forms.impressos.cabecalho_posicao_logo"
                label="Posição do logo no cabeçalho"
                :items="posicaoOpts"
                clearable
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="forms.impressos.rodape_posicao"
                label="Posição do rodapé"
                :items="posicaoOpts"
                clearable
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="forms.impressos.rodape_texto"
                label="Texto do rodapé"
                clearable
                dense
                outlined
                hide-details
              />
            </v-col>
          </v-row>
          <v-row
            dense
            class="mt-2"
          >
            <v-col
              v-for="f in numericImpressoFields"
              :key="f.key"
              cols="6"
              md="3"
            >
              <v-text-field
                v-model.number="forms.impressos[f.key]"
                :label="f.label"
                type="number"
                step="0.1"
                dense
                outlined
                hide-details
              />
            </v-col>
          </v-row>
          <v-row
            dense
            class="mt-2"
          >
            <v-col
              v-for="f in impressoSwitches"
              :key="f.key"
              cols="12"
              md="4"
            >
              <v-switch
                v-model="forms.impressos[f.key]"
                :label="f.label"
                inset
                dense
                hide-details
              />
            </v-col>
          </v-row>
          <div class="mt-3 text-right">
            <v-btn
              color="secondary"
              small
              :loading="saving.impressos"
              @click="save('impressos')"
            >
              Salvar
            </v-btn>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Portal -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="d-flex align-center">
            <v-icon
              color="info"
              class="mr-2"
            >
              mdi-web
            </v-icon>
            <div>
              <div class="text-subtitle-1">
                Portal do paciente
              </div>
              <div class="text-caption grey--text">
                Habilitação, tema e regras do portal público.
              </div>
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row dense>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="forms.portal.shortName"
                label="Shortname"
                hint="Identificador único usado na URL pública"
                clearable
                dense
                outlined
                persistent-hint
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="forms.portal.tema"
                label="Tema"
                clearable
                dense
                outlined
                hide-details
              />
            </v-col>
          </v-row>
          <v-row
            dense
            class="mt-2"
          >
            <v-col
              v-for="f in portalSwitches"
              :key="f.key"
              cols="12"
              md="6"
              lg="4"
            >
              <v-switch
                v-model="forms.portal[f.key]"
                :label="f.label"
                inset
                dense
                hide-details
              />
            </v-col>
          </v-row>
          <div class="mt-3 text-right">
            <v-btn
              color="secondary"
              small
              :loading="saving.portal"
              @click="save('portal')"
            >
              Salvar
            </v-btn>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Pacientes -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="d-flex align-center">
            <v-icon
              color="primary"
              class="mr-2"
            >
              mdi-account-details-outline
            </v-icon>
            <div>
              <div class="text-subtitle-1">
                Cadastro de pacientes
              </div>
              <div class="text-caption grey--text">
                Campos obrigatórios no cadastro do paciente.
              </div>
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            dense
            class="mt-2"
          >
            <v-col
              v-for="f in pacientesSwitches"
              :key="f.key"
              cols="12"
              md="6"
              lg="4"
            >
              <v-switch
                v-model="forms.pacientes[f.key]"
                :label="f.label"
                inset
                dense
                hide-details
              />
            </v-col>
          </v-row>
          <div class="mt-3 text-right">
            <v-btn
              color="secondary"
              small
              :loading="saving.pacientes"
              @click="save('pacientes')"
            >
              Salvar
            </v-btn>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      top
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
  import { $k } from '@/lib/kraken'

  const AGENDA_SWITCHES = [
    { key: 'exibe_chegada_paciente', label: 'Exibe chegada do paciente' },
    { key: 'exibe_espera_paciente', label: 'Exibe tempo de espera' },
    { key: 'oculta_slots_livres', label: 'Oculta slots livres' },
    { key: 'oculta_slots_bloqueados', label: 'Oculta slots bloqueados' },
    { key: 'oculta_observacoes', label: 'Oculta observações' },
  ]

  const IMPRESSO_SWITCHES = [
    { key: 'cabecalho_mostra_nome', label: 'Cabeçalho exibe nome' },
    { key: 'cabecalho_mostra_logo', label: 'Cabeçalho exibe logo' },
    { key: 'conselho_exibe_nome', label: 'Exibir nome do conselho' },
    { key: 'conselho_exibe_valor', label: 'Exibir valor do conselho' },
  ]

  const NUMERIC_IMPRESSO = [
    { key: 'margens_superior_cm', label: 'Margem superior (cm)' },
    { key: 'margens_esquerda_cm', label: 'Margem esquerda (cm)' },
    { key: 'margens_inferior_cm', label: 'Margem inferior (cm)' },
    { key: 'margens_direita_cm', label: 'Margem direita (cm)' },
    { key: 'coordenadas_assinatura_x', label: 'Assinatura X' },
    { key: 'coordenadas_assinatura_y', label: 'Assinatura Y' },
  ]

  const PORTAL_SWITCHES = [
    { key: 'habilitado', label: 'Portal habilitado' },
    { key: 'habilita_confirmacao', label: 'Habilita confirmação' },
    { key: 'habilita_agendamento', label: 'Habilita agendamento' },
    { key: 'habilita_checkin', label: 'Habilita check-in' },
    { key: 'habilita_agendamento_futuro', label: 'Habilita agendamento futuro' },
    { key: 'exibe_popup_checkin_apos_agendar', label: 'Popup de check-in após agendar' },
    { key: 'bloqueia_retorno', label: 'Bloqueia retorno' },
    { key: 'bloqueia_retorno_qualquer_medico', label: 'Bloqueia retorno (qualquer médico)' },
    { key: 'bloqueia_retorno_por_agendamentos', label: 'Bloqueia retorno por agendamentos' },
    { key: 'bloqueia_retorno_qualquer_medico_por_agendamentos', label: 'Bloqueia retorno por agendamentos (qualquer médico)' },
    { key: 'bloqueia_retorno_se_agendamento_futuro', label: 'Bloqueia retorno se houver agendamento futuro' },
  ]

  const PACIENTES_SWITCHES = [
    { key: 'obrigatorio_nome_social', label: 'Nome social obrigatório' },
    { key: 'obrigatorio_cpf', label: 'CPF obrigatório' },
    { key: 'obrigatorio_cns', label: 'CNS obrigatório' },
    { key: 'obrigatorio_rg', label: 'RG obrigatório' },
    { key: 'obrigatorio_data_nascimento', label: 'Data de nascimento obrigatória' },
    { key: 'obrigatorio_sexo', label: 'Sexo obrigatório' },
    { key: 'obrigatorio_nome_mae', label: 'Nome da mãe obrigatório' },
    { key: 'obrigatorio_cpf_mae', label: 'CPF da mãe obrigatório' },
    { key: 'obrigatorio_nome_pai', label: 'Nome do pai obrigatório' },
    { key: 'obrigatorio_cpf_pai', label: 'CPF do pai obrigatório' },
    { key: 'obrigatorio_etnia', label: 'Etnia obrigatória' },
    { key: 'obrigatorio_estado_civil', label: 'Estado civil obrigatório' },
    { key: 'obrigatorio_espectro_autista', label: 'Espectro autista obrigatório' },
    { key: 'obrigatorio_nacionalidade', label: 'Nacionalidade obrigatória' },
    { key: 'obrigatorio_naturalidade', label: 'Naturalidade obrigatória' },
    { key: 'obrigatorio_profissao', label: 'Profissão obrigatória' },
    { key: 'obrigatorio_indicado_por', label: 'Indicado por obrigatório' },
    { key: 'obrigatorio_endereco', label: 'Endereço obrigatório' },
    { key: 'obrigatorio_contato', label: 'Contato obrigatório' },
  ]

  function emptyForms () {
    return {
      geral: {
        permite_configuracao_agenda: false,
        permite_configuracao_prontuario: false,
        permite_configuracao_impresso: false,
      },
      prontuario: {
        evolucao_vista_padrao: 'TEXTO_SIMPLES',
      },
      agenda: {
        vista_padrao: 'dia',
        exibe_chegada_paciente: false,
        exibe_espera_paciente: false,
        oculta_slots_livres: false,
        oculta_slots_bloqueados: false,
        oculta_observacoes: false,
      },
      impressos: {
        cabecalho_mostra_nome: null,
        cabecalho_mostra_logo: null,
        cabecalho_posicao_logo: null,
        rodape_posicao: null,
        coordenadas_assinatura_x: null,
        coordenadas_assinatura_y: null,
        rodape_texto: null,
        margens_superior_cm: null,
        margens_esquerda_cm: null,
        margens_inferior_cm: null,
        margens_direita_cm: null,
        formato_pagina: null,
        conselho_exibe_nome: null,
        conselho_exibe_valor: null,
      },
      portal: {
        shortName: null,
        habilitado: false,
        tema: null,
        habilita_confirmacao: false,
        habilita_agendamento: false,
        habilita_checkin: false,
        habilita_agendamento_futuro: false,
        exibe_popup_checkin_apos_agendar: false,
        bloqueia_retorno: false,
        bloqueia_retorno_qualquer_medico: false,
        bloqueia_retorno_por_agendamentos: false,
        bloqueia_retorno_qualquer_medico_por_agendamentos: false,
        bloqueia_retorno_se_agendamento_futuro: false,
      },
      pacientes: {
        obrigatorio_nome_social: false,
        obrigatorio_cpf: false,
        obrigatorio_cns: false,
        obrigatorio_rg: false,
        obrigatorio_data_nascimento: false,
        obrigatorio_sexo: false,
        obrigatorio_nome_mae: false,
        obrigatorio_cpf_mae: false,
        obrigatorio_nome_pai: false,
        obrigatorio_cpf_pai: false,
        obrigatorio_etnia: false,
        obrigatorio_estado_civil: false,
        obrigatorio_espectro_autista: false,
        obrigatorio_nacionalidade: false,
        obrigatorio_naturalidade: false,
        obrigatorio_profissao: false,
        obrigatorio_indicado_por: false,
        obrigatorio_endereco: false,
        obrigatorio_contato: false,
      },
    }
  }

  export default {
    name: 'SettingsTab',

    props: {
      org: { type: Object, required: true },
    },

    data: () => ({
      openPanels: [0],
      loading: false,
      loadError: '',
      forms: emptyForms(),
      saving: { geral: false, prontuario: false, agenda: false, impressos: false, portal: false, pacientes: false },
      snackbar: { show: false, color: 'success', text: '' },
      agendaSwitches: AGENDA_SWITCHES,
      impressoSwitches: IMPRESSO_SWITCHES,
      numericImpressoFields: NUMERIC_IMPRESSO,
      portalSwitches: PORTAL_SWITCHES,
      pacientesSwitches: PACIENTES_SWITCHES,
      vistaAgendaOpts: [
        { text: 'Dia', value: 'dia' },
        { text: 'Semana', value: 'semana' },
        { text: 'Mês', value: 'mes' },
      ],
      evolucaoOpts: [
        { text: 'Texto simples', value: 'TEXTO_SIMPLES' },
        { text: 'SOAP', value: 'SOAP' },
        { text: 'Oftalmologia', value: 'OFTALMO' },
      ],
      formatoPaginaOpts: [
        { text: 'A4', value: 'A4' },
        { text: 'A5', value: 'A5' },
      ],
      posicaoOpts: [
        { text: 'Início', value: 'start' },
        { text: 'Centro', value: 'center' },
        { text: 'Fim', value: 'end' },
      ],
    }),

    watch: {
      'org.id': {
        immediate: true,
        handler () { this.load() },
      },
    },

    methods: {
      pickKnownKeys (target, source) {
        if (!source) return
        for (const k of Object.keys(target)) {
          if (source[k] !== undefined) target[k] = source[k]
        }
      },
      async load () {
        if (!this.org?.id) return
        this.loading = true
        this.loadError = ''
        this.forms = emptyForms()
        try {
          const res = await $k.manage.clinic_one.organizations._id.settings.get({ id: this.org.id })
          this.pickKnownKeys(this.forms.geral, res.configuracao_geral)
          this.pickKnownKeys(this.forms.prontuario, res.configuracao_prontuario)
          this.pickKnownKeys(this.forms.agenda, res.configuracao_agenda)
          this.pickKnownKeys(this.forms.impressos, res.configuracao_impressos)
          this.pickKnownKeys(this.forms.portal, res.configuracao_portal)
          this.pickKnownKeys(this.forms.pacientes, res.configuracao_pacientes)
        } catch (err) {
          console.error('[settings.get]', err)
          this.loadError = err?.response?.data?.messages?.[0]?.text || err?.message || 'Falha ao carregar configurações.'
        } finally {
          this.loading = false
        }
      },
      async save (group) {
        if (!this.org?.id) return
        this.saving[group] = true
        try {
          const bodyKey = `configuracao_${group}`
          const body = { [bodyKey]: { ...this.forms[group] } }
          const res = await $k.manage.clinic_one.organizations._id.settings.put({ id: this.org.id, ...body })
          this.pickKnownKeys(this.forms.geral, res.configuracao_geral)
          this.pickKnownKeys(this.forms.prontuario, res.configuracao_prontuario)
          this.pickKnownKeys(this.forms.agenda, res.configuracao_agenda)
          this.pickKnownKeys(this.forms.impressos, res.configuracao_impressos)
          this.pickKnownKeys(this.forms.portal, res.configuracao_portal)
          this.pickKnownKeys(this.forms.pacientes, res.configuracao_pacientes)
          this.snackbar = { show: true, color: 'success', text: 'Configurações salvas.' }
        } catch (err) {
          console.error('[settings.put]', err)
          const msg = err?.response?.data?.messages?.[0]?.text || err?.message || 'Falha ao salvar.'
          this.snackbar = { show: true, color: 'error', text: msg }
        } finally {
          this.saving[group] = false
        }
      },
    },
  }
</script>
